import { render } from "./UsersRoles.vue?vue&type=template&id=792a4910&scoped=true"
import script from "./UsersRoles.vue?vue&type=script&lang=js"
export * from "./UsersRoles.vue?vue&type=script&lang=js"

import "./UsersRoles.vue?vue&type=style&index=0&id=792a4910&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-792a4910"]])

export default __exports__